import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Fullscreen from 'material-ui/svg-icons/navigation/fullscreen';
import {Paper, Subheader} from "material-ui";
import DropDownMenu from 'material-ui/DropDownMenu';
import FullscreenExit from 'material-ui/svg-icons/navigation/fullscreen-exit';
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import {fetchApp} from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './ReportPage.css';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import {grey400, white} from 'material-ui/styles/colors';
import AdminService, {ADMIN} from '../../../services/admin';
import PointInfo from "../../../components/openexplore/PointInfo/PointInfo";
import {getTypes} from "../../../store/types/actions";
import {getCustomFields} from "../../../store/customfields/actions";
import Mapbox from "../../../components/openexplore/Mapbox/Mapbox";
import withTranslation from "../../../hoc/withTranslation";
import {
    REPORTS_PAGE,
    EDIT_OPENEXPLORE_MEDIA_PAGE
} from "../../../constants/routes";
import {
    deleteReport,
    fetchReport,
    getReport,
    getReports,
    postReportItem,
    postReportMedia,
    putReport,
    postReportItemMedia
} from "../../../store/reports/action";
import ReportTalk from "../../../components/report/ReportTalk/ReportTalk";

import {reportStates, stateColors, stateTextColors} from '../../../constants/reports'

const iconButtonElement = (
    <IconButton touch={true} tooltipPosition="bottom-left">
        <MoreVertIcon color={grey400} />
    </IconButton>
);

export class ReportPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        report: PropTypes.object
    };

    static defaultProps = {};

    state = {
        openRemoveReport: false,
        mapFullscreen: false
    };

    componentWillMount() {
        this.fetch();

        if (this.props.app) {
            this.props.getTypes(this.props.app.id, this.props.currentLang);
            this.props.getCustomFields(this.props.app.id);
        }

        if (this.props.report) {
            this.setState({
                latlng: {
                    lat: this.props.report.latitude,
                    lng: this.props.report.longitude,
                    shouldCenter: true
                },
                state: reportStates.indexOf(this.props.report.state)
            });
        }
    }

    componentWillReceiveProps(nextProps) {

        if (this.props.reports !== nextProps.reports || this.props.match !== nextProps.match || this.props.currentLang !== nextProps.currentLang) {
            this.fetch(nextProps.match.params.appId, nextProps.match.params.reportId, nextProps.currentLang)
        }

        if (this.props.sending && !nextProps.sending) {
            if (!nextProps.report) {
                this.props.history.push(REPORTS_PAGE.replace(':appId', this.props.app.id));
            }
        }

        if (nextProps.app && this.props.app !== nextProps.app) {
            this.props.getTypes(nextProps.app.id, nextProps.currentLang);
            this.props.getCustomFields(nextProps.app.id);
            this.props.getReports(nextProps.app, nextProps.currentLang);
        }

        if (nextProps.report && (!this.state.latlng || this.props.report !== nextProps.report)) {
            this.setState({
                latlng: {
                    lat: nextProps.report.latitude,
                    lng: nextProps.report.longitude,
                    shouldCenter: true
                },
                state: nextProps.report.state
            });
        }
    }

    // Delete point

    handleOpenReport = () => {
        this.setState({openRemoveReport: true});
    };

    handleCloseReport = () => {
        this.setState({openRemoveReport: false});
    };

    handleStateChange = (event, index, value) => {
        this.setState({state: value});
        this.props.putReport(this.props.app.id,
            {
                ...this.props.report,
                state: value
            },
            this.props.currentLang
        ).then(value => {
            if (value) {
                this.fetchReport();
            }
        });
    };

    addItemReport = (itemText, picture, pushEntity) => {
        this.props.postReportItem(
            this.props.app.id,
            this.props.report,
            {response: itemText, push_entity: pushEntity},
            this.props.currentLang
        ).then(value => {
            if (value) {
                if (picture) {
                    this.props.postReportItemMedia(
                        this.props.app.id,
                        this.props.report,
                        value,
                        picture,
                        this.props.currentLang
                    ).then(value => {
                        if (value) {
                            this.props.getReports(this.props.app, this.props.currentLang);
                        }
                    });
                } else {
                    this.props.getReports(this.props.app, this.props.currentLang);
                }
            }
        });
    };

    deleteReport = () => {
        this.props.deleteReport(this.props.app.id, this.props.report.id, this.props.currentLang).then(() => {
            this.setState({ openRemoveReport: false });
            this.props.history.push(REPORTS_PAGE.replace(':appId', this.props.app.id));
        });
    };

    editMedia = (mediaId) => {
        let url = EDIT_OPENEXPLORE_MEDIA_PAGE
            .replace(':appId', this.props.app.id)
            .replace(':entityType', 'reports')
            .replace(':entityId', this.props.point.id)
            .replace(':mediaId', mediaId);
        this.props.history.push(url);
    };

    switchFullScreen = () => {
        this.setState({
            mapFullscreen: !this.state.mapFullscreen
        })
    };


    // Fetch

    fetch(appId = null, reportId = null, lang = null) {
        this.fetchApplication(appId);
        this.fetchReport(appId, reportId, lang);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    fetchReport(appId = null, reportId = null, fetchLang = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const report = reportId || this.props.match.params.reportId;
            const lang = fetchLang || this.props.currentLang;

            if (app && report) {
                this.props.fetchReport(app, report, lang)
            }
        }
    }

    postReportItem(item, appId = null, report = null, fetchLang = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const r = report || this.props.report;
            const lang = fetchLang || this.props.currentLang;

            if (app && report && item) {
                this.props.postReportItem(app, r, item, lang)
            }
        }
    }

    // Render

    renderMenu() {
        let menu;

        if (AdminService.isAuthorized(ADMIN, this.props.user)) {
            menu = (
                <IconMenu
                    style={styles.buttons}
                    iconButtonElement={iconButtonElement}
                    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                    targetOrigin={{horizontal: 'right', vertical: 'top'}}>
                    <MenuItem onClick={this.handleOpenReport}>
                        {this.props.t('generic.remove')}
                    </MenuItem>
                </IconMenu>
            );
        }

        return menu;
    };

    renderDeleteReportDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseReport}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteReport}
            />
        ];

        return (
            <Dialog
                actions={actions}
                modal={false}
                open={this.state.openRemoveReport}
                onRequestClose={this.handleCloseReport}
            >
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                <p>{this.props.t('module.report.delete_report_confirmation')}</p>
                }
            </Dialog>
        );
    }

    renderMap() {
        return (
            <div>
                <Paper>
                    <Subheader style={{...style.subHeader, ...style.relative}}>
                        {this.props.t('generic.map')}
                        <IconButton
                            style={styles.rightIcon}
                            tooltip={this.props.t('module.open_explore.map_fullscreen')}
                            tooltipPosition='bottom-left'
                            onClick={this.switchFullScreen}
                        >
                            {this.state.mapFullscreen ?
                                <FullscreenExit color={white} />
                                :
                                <Fullscreen color={white} />
                            }
                        </IconButton>
                    </Subheader>
                    <Mapbox
                        latlng={this.state.latlng}
                        scrollWheelZoom={false}
                        canShowDetail={false}
                        points={[]}
                        trails={[]}
                        style={this.state.mapFullscreen ? styles.mapFull : styles.map}
                        mapStyle={this.props.mapStyle}
                    />
                </Paper>
            </div>
        );
    }

    renderInformation() {
        return (
            <div>
                <PointInfo
                    point={this.props.report}
                    customFields={this.props.customFields}
                    app={this.props.app}
                    lang={this.props.currentLang}
                    disabledHeaderIcons={true}
                />
            </div>
        );
    }

    renderSubjectAndItems() {
        return (
            <ReportTalk
                report={this.props.report}
                items={this.props.report.items}
                onClickAnswer={this.addItemReport}
                authUsername={this.props.user.username}
                state={this.state.state}
                app={this.props.app}
            />
        );
    }

    renderStatusButton() {
        return (
            <DropDownMenu
                style={styles.statusButton}
                value={this.state.state}
                onChange={this.handleStateChange}
                iconStyle={{color: stateTextColors[reportStates.indexOf(this.state.state)]}}
                underlineStyle={{
                    bottom: '8px',
                    borderTop: '1px solid ' + stateColors[reportStates.indexOf(this.state.state)]
                }}
            >
                <MenuItem
                    value={reportStates[0]}
                    primaryText={this.props.t('module.report.state.new')}
                />
                <MenuItem
                    value={reportStates[1]}
                    primaryText={this.props.t('module.report.state.in_treatment')}
                />
                <MenuItem
                    value={reportStates[2]}
                    primaryText={this.props.t('module.report.state.treated')}
                />
                <MenuItem
                    value={reportStates[3]}
                    primaryText={this.props.t('module.report.state.refused')}
                />
            </DropDownMenu>
        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.app && this.props.report) {
            return (
                <div>
                    {this.renderDeleteReportDialog()}
                    <div>
                        {this.renderMenu()}
                        <h3 style={style.navigation}>
                            {this.props.t('module.report.name')} / {this.props.t('generic.detail')}
                        </h3>
                        <div style={styles.titleBar}>
                            <div style={styles.title}>{this.props.report.title} -</div>
                            {this.renderStatusButton()}
                        </div>
                        <div>
                            <div className="row">
                                <div style={style.col} className="col-xs-12 col-sm-6 col-md-6">
                                    {this.props.report.latitude && this.props.report.longitude && this.renderMap()}
                                    {this.renderInformation()}
                                </div>
                                <div style={style.col} className="col-xs-12 col-sm-6 col-md-6">
                                    {this.renderSubjectAndItems()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return <Loading paper={false} />;
        }
    }
}

function mapStateToProps(state) {
    return {
        mapStyle: state.ui.mapStyle,
        error: state.apps.error || state.reports.error,
        user: state.auth.content,
        loading: state.apps.pending || state.reports.pending,
        sending: state.reports.sending,
        report: state.reports.currentReport,
        currentLang: state.ui.currentLang,
        app: state.apps.currentApplication,
        reports: state.reports.content,
        types: state.types.content,
        typesPending: state.types.pending,
        customFields: state.customFields.content
    };
}

export default connect(mapStateToProps, {
    postReportMedia,
    postReportItem,
    postReportItemMedia,
    fetchApp,
    fetchReport,
    getReports,
    getReport,
    getTypes,
    putReport,
    getCustomFields,
    deleteReport
})(withTranslation(ReportPage));



// WEBPACK FOOTER //
// src/containers/reports/ReportPage/ReportPage.js